import { useEffect, useState } from "react";
import { api } from "../api";

/** Tiny "v0.0.1" in the top-right corner; the value comes from the database via /api/version. */
export default function VersionBadge() {
  const [info, setInfo] = useState<{ version: string; since: string | null } | null>(null);

  useEffect(() => {
    api.version().then(setInfo).catch(() => {});
  }, []);

  if (!info) return null;
  const since = info.since ? new Date(info.since).toLocaleString("en-GB") : "";
  return (
    <div
      className="pointer-events-none fixed right-3 z-40 text-[11px] font-semibold text-ink/20 select-none"
      style={{ top: "calc(env(safe-area-inset-top, 0px) + 6px)" }}
      title={since ? `Deployed ${since}` : undefined}
      aria-label={`Version ${info.version}`}
    >
      v{info.version}
    </div>
  );
}
